const RemoveSplashPage = {
  invoke: {
    remove() {
      const el = window.document.getElementById('splash-page');
      if (el) {
        el.classList.add('splash-page--hidden');
        setTimeout(() => el.remove(), 1100);
      }
    },
  },
};

export default RemoveSplashPage;
